import store from '@shared/store/index';

const openLegendSubscribe = () => {
  store.dispatch('HeaderSystem/openSubscriptionWidgetFromLegend');
}

const openGiftSubscribe = () => {
  store.dispatch('HeaderSystem/changeGiftWidget', true);
}

export function subscribeWidget(){
  return{
    openLegendSubscribe,
    openGiftSubscribe
  }
}